import React, { useState } from 'react'
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
} from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import useAuth from 'app/hooks/useAuth'
import history from 'history.js'
import axios from 'axios.js'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    root:{
        borderRadius:10
    },
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        maxWidth: 420,
        width: '100%',
        borderRadius: 16,
        margin: '1rem',
        boxShadow:"0px 0px 13px 3px #eeeeee"
    },
    agreementBox: {
        marginBottom: theme.spacing(1.5),
        padding: '8px 10px',
        border: '1px solid #e5e7eb',
        borderRadius: 10,
        background: '#f8fafc',
    },
    agreementControl: {
        margin: 0,
        alignItems: 'flex-start',
        width: '100%',
        '& .MuiFormControlLabel-label': {
            display: 'block',
            width: '100%',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        },
    },
    agreementLabelText: {
        fontSize: 13,
        lineHeight: '18px',
        color: '#0f172a',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    agreementLinks: {
        marginTop: 6,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 8,
    },
    agreementLink: {
        color: '#5b7bb7',
        textDecoration: 'none',
        fontSize: 12,
        '&:hover': {
            color: '#2f4f8f',
            textDecoration: 'underline',
        },
    },
}))

const JwtRegister = () => {
    const [state, setState] = useState({})
    const [message, setMessage] = useState('')
    const [legal, setLegal] = useState({
        legal_checkbox1_enabled: true,
        legal_checkbox1_required: true,
        legal_checkbox1_label: 'Принимаю Пользовательское соглашение и Публичную оферту',
        legal_checkbox2_enabled: true,
        legal_checkbox2_required: true,
        legal_checkbox2_label: 'Даю согласие на обработку персональных данных в соответствии с Политикой конфиденциальности',
        legal_checkbox3_enabled: false,
        legal_checkbox3_required: false,
        legal_checkbox3_label: 'Согласен получать информационные и рекламные сообщения',
        legal_terms_url: '/session/legal/terms',
        legal_privacy_url: '/session/legal/privacy',
        legal_offer_url: '/session/legal/offer',
        legal_marketing_url: '/session/legal/marketing',
    })
    const classes = useStyles()
    const { register } = useAuth()

    React.useEffect(() => {
        let mounted = true
        axios.get('/api/auth/legal')
            .then((res) => {
                if (!mounted) return
                const payload = res?.data || {}
                if (payload?.error) return
                const data = payload?.data || {}
                setLegal((prev) => ({ ...prev, ...data }))
            })
            .catch(() => {})
        return () => { mounted = false }
    }, [])

    const handleChange = ({ target: { name, value } }) => {
        setState({
            ...state,
            [name]: value,
        })
    }

    const handleFormSubmit = async () => {
        setMessage('')
        if (legal.legal_checkbox1_enabled && legal.legal_checkbox1_required && !state.agreement1) {
            setMessage('Нужно принять Пользовательское соглашение и Публичную оферту')
            return
        }
        if (legal.legal_checkbox2_enabled && legal.legal_checkbox2_required && !state.agreement2) {
            setMessage('Нужно дать согласие на обработку персональных данных')
            return
        }
        if (legal.legal_checkbox3_enabled && legal.legal_checkbox3_required && !state.agreement3) {
            setMessage('Нужно подтвердить согласие на получение сообщений')
            return
        }
        try {
            await register(state.email, state.username, state.password, {
                agreement1: !!state.agreement1,
                agreement2: !!state.agreement2,
                agreement3: !!state.agreement3,
                accept_source: 'web_register',
            })
            history.push('/')
        } catch (e) {
            console.log(e)
            setMessage(e?.response?.data?.message || e?.message || 'Ошибка регистрации')
        }
    }

    let { username, email, password, agreement1, agreement2, agreement3 } = state

    return (
        <div
            className={clsx(
                'flex justify-center items-center  min-h-full-screen',
                // classes.cardHolder
            )}
        >
            <Card className={classes.card}>
                <div style={{ textAlign: 'center', fontSize: 50, fontFamily: 'Cocomat', marginTop: '10%' }}>pixel<span style={{ color: '#9400d3' }}>crm</span></div>
                <Grid container>
                    {/*<Grid item lg={5} md={5} sm={5} xs={12}>*/}
                    {/*    <div className="p-8 flex justify-center bg-light-gray items-center h-full">*/}
                    {/*        <img*/}
                    {/*            className="w-full"*/}
                    {/*            src="/assets/images/illustrations/posting_photo.svg"*/}
                    {/*            alt=""*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</Grid>*/}
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="p-8 h-full">
                            <ValidatorForm onSubmit={handleFormSubmit}>
                                <TextValidator
                                    className="mb-6 w-full"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        classes:{
                                            root: classes.root
                                        }
                                    }}
                                    label="Имя пользователя"
                                    onChange={handleChange}
                                    type="text"
                                    name="username"
                                    value={username || ''}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />
                                <TextValidator
                                    className="mb-6 w-full"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        classes:{
                                            root: classes.root
                                        }
                                    }}
                                    label="Почта"
                                    onChange={handleChange}
                                    type="email"
                                    name="email"
                                    value={email || ''}
                                    validators={['required', 'isEmail']}
                                    errorMessages={[
                                        'Поле обязательно для заполнения',
                                        'Введите корректный email',
                                    ]}
                                />
                                <TextValidator
                                    className="mb-4 w-full"
                                    label="Пароль"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        classes:{
                                            root: classes.root
                                        }
                                    }}
                                    onChange={handleChange}
                                    name="password"
                                    type="password"
                                    value={password || ''}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />
                                {!!legal.legal_checkbox1_enabled && (
                                    <div className={classes.agreementBox}>
                                        <FormControlLabel
                                            className={classes.agreementControl}
                                            name="agreement1"
                                            onChange={(e) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement1',
                                                        value: e.target.checked,
                                                    },
                                                })
                                            }
                                            control={<Checkbox size="small" checked={agreement1 || false} />}
                                            label={(
                                                <div>
                                                    <div className={classes.agreementLabelText}>
                                                        {legal.legal_checkbox1_label}
                                                        {legal.legal_checkbox1_required ? ' *' : ''}
                                                    </div>
                                                    <div className={classes.agreementLinks}>
                                                        <Link className={classes.agreementLink} to={legal.legal_terms_url || '/session/legal/terms'} target="_blank" onClick={(e) => e.stopPropagation()}>
                                                            Пользовательское соглашение
                                                        </Link>
                                                        <Link className={classes.agreementLink} to={legal.legal_offer_url || '/session/legal/offer'} target="_blank" onClick={(e) => e.stopPropagation()}>
                                                            Публичная оферта
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </div>
                                )}
                                {!!legal.legal_checkbox2_enabled && (
                                    <div className={classes.agreementBox}>
                                        <FormControlLabel
                                            className={classes.agreementControl}
                                            name="agreement2"
                                            onChange={(e) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement2',
                                                        value: e.target.checked,
                                                    },
                                                })
                                            }
                                            control={<Checkbox size="small" checked={agreement2 || false} />}
                                            label={(
                                                <div>
                                                    <div className={classes.agreementLabelText}>
                                                        {legal.legal_checkbox2_label}
                                                        {legal.legal_checkbox2_required ? ' *' : ''}
                                                    </div>
                                                    <div className={classes.agreementLinks}>
                                                        <Link className={classes.agreementLink} to={legal.legal_privacy_url || '/session/legal/privacy'} target="_blank" onClick={(e) => e.stopPropagation()}>
                                                            Политика конфиденциальности
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </div>
                                )}
                                {!!legal.legal_checkbox3_enabled && (
                                    <div className={classes.agreementBox}>
                                        <FormControlLabel
                                            className={classes.agreementControl}
                                            name="agreement3"
                                            onChange={(e) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement3',
                                                        value: e.target.checked,
                                                    },
                                                })
                                            }
                                            control={<Checkbox size="small" checked={agreement3 || false} />}
                                            label={(
                                                <div>
                                                    <div className={classes.agreementLabelText}>
                                                        {`${legal.legal_checkbox3_label}${legal.legal_checkbox3_required ? ' *' : ''}`}
                                                    </div>
                                                    <div className={classes.agreementLinks}>
                                                        <Link className={classes.agreementLink} to={legal.legal_marketing_url || '/session/legal/marketing'} target="_blank" onClick={(e) => e.stopPropagation()}>
                                                            Согласие на получение рекламных сообщений
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </div>
                                )}
                                {!!message && (
                                    <div style={{ color: '#b91c1c', marginBottom: 10 }}>{message}</div>
                                )}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                    <Button
                                        className="capitalize"
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        fullWidth
                                    >
                                        Зарегистрироваться
                                    </Button>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
                                    <Link to="/session/signin">
                                        <Button className="capitalize">
                                            Войти
                                        </Button>
                                    </Link>
                                    <Link to="/others/tariffs">
                                        <Button className="capitalize">
                                            Тарифы
                                        </Button>
                                    </Link>
                                    <Link to="/help">
                                        <Button className="capitalize">Как начать работу</Button>
                                    </Link>
                                    </div>
                                </div>
                            </ValidatorForm>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </div>
    )
}

export default JwtRegister
